import { render, staticRenderFns } from "./openPositionRpt.vue?vue&type=template&id=0ffa87fe&scoped=true&"
import script from "./openPositionRpt.vue?vue&type=script&lang=js&"
export * from "./openPositionRpt.vue?vue&type=script&lang=js&"
import style0 from "./openPositionRpt.vue?vue&type=style&index=0&id=0ffa87fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa87fe",
  null
  
)

export default component.exports